module.exports = __webpack_public_path__ + "static/ivan-b840846ddf9862e2b06df93349073618.png";